module.exports = __webpack_public_path__ + "img/informations.e9363b00.svg";